import Vue from 'vue'
import VeeValidate, {
    Validator
} from 'vee-validate'
import pt_BR from 'vee-validate/dist/locale/pt_BR';

//if (this.$i18n.locale == 'pt')
    Validator.localize("pt_BR", pt_BR);

Vue.use(VeeValidate, {
    // This is the default
    inject: true,
    // Important to name this something other than 'fields'
    fieldsBagName: 'veeFields',
    // This is not required but avoids possible naming conflicts
    errorBagName: 'veeErrors'
})